import {DEFAULT_ACCOUNT_ROUTE_NAME, DEFAULT_PROJECT_ROUTE_NAME} from 'router/constants';

export const SET_CURRENT_ACCOUNT_ROUTE = 'SET_CURRENT_ACCOUNT_ROUTE';
export const SET_CURRENT_PROJECT_ROUTE = 'SET_CURRENT_PROJECT_ROUTE';
export const SET_CURRENT_ROUTE = 'SET_CURRENT_ROUTE';
export const SET_IS_ROUTER_LOCKED = 'SET_IS_ROUTER_LOCKED';
export const SET_PREV_ROUTE = 'SET_PREV_ROUTE';
export const RESET_PREV_ROUTES = 'RESET_PREV_ROUTES';

const excludedAccountRoutes = new Set([
  'projectsList', 'account', 'accounts', 'aoriBalance', 'financialReports', 'planFact',
  'brokerReports', 'brokerPlacementsUnlinked', 'brokerPlacementsExcluded', 'accountingReport',
  'projectCreate', 'accountCreate'
]);

const excludedProjectRoutes = new Set([]);

const routingStore = {
  namespaced: true,
  state: {
    currentAccountRoute: null,
    currentProjectRoute: null,
    currentRoute: null,
    prevRoute: null,
    isRouterLocked: false
  },
  mutations: {
    SET_CURRENT_ACCOUNT_ROUTE (state, route) {
      state.currentAccountRoute = route;
    },
    SET_CURRENT_PROJECT_ROUTE (state, route) {
      state.currentProjectRoute = route;
    },
    SET_CURRENT_ROUTE (state, route) {
      state.currentRoute = route;
    },
    SET_IS_ROUTER_LOCKED (state, isRouterLocked) {
      state.isRouterLocked = isRouterLocked;
    },
    [SET_PREV_ROUTE] (state, route) {
      state.prevRoute = route;
    },
    RESET_INSTRUMENT_ROUTES (state) {
      state.currentAccountRoute = null;
      state.currentProjectRoute = null;
    }
  },
  getters: {
    currentAccountRoute (state) {
      return state.currentAccountRoute;
    },
    currentProjectRoute (state) {
      return state.currentProjectRoute;
    },
    currentRoute (state) {
      return state.currentRoute;
    },
    prevRoute (state) {
      return state.prevRoute;
    },
    currentAccountUrlName (state, getters) {
      const route = getters.currentAccountRoute;
      const routeName = route && route.name;

      // account route can have only 1 param - accountId
      const hasExtraParams = routeName && (Object.keys(route.params).length !== 1 || !route.params.accountId);
      if (hasExtraParams || !routeName || excludedAccountRoutes.has(routeName)) {
        return DEFAULT_ACCOUNT_ROUTE_NAME;
      }
      return routeName;
    },
    currentProjectUrlName (state, getters) {
      const route = getters.currentProjectRoute;
      const routeName = route && route.name;

      // project route can have only 2 param - accountId and projectId
      const hasExtraParams = routeName && (
        Object.keys(route.params).length !== 2 || !route.params.accountId || !route.params.projectId
      );
      if (hasExtraParams || !routeName || excludedProjectRoutes.has(routeName)) {
        return DEFAULT_PROJECT_ROUTE_NAME;
      }
      return routeName;
    }
  },
  actions: {
    async [SET_CURRENT_ACCOUNT_ROUTE] (context, route) {
      return context.commit('SET_CURRENT_ACCOUNT_ROUTE', route);
    },
    async [SET_CURRENT_PROJECT_ROUTE] (context, route) {
      return context.commit('SET_CURRENT_PROJECT_ROUTE', route);
    },
    async [SET_CURRENT_ROUTE] (context, route) {
      return context.commit('SET_CURRENT_ROUTE', route);
    },
    async [SET_IS_ROUTER_LOCKED] (context, isRouterLocked) {
      return context.commit('SET_IS_ROUTER_LOCKED', isRouterLocked);
    },
    async [SET_PREV_ROUTE] (context, route) {
      return context.commit(SET_PREV_ROUTE, route);
    },
    async RESET_INSTRUMENT_ROUTES (context) {
      return context.commit('RESET_INSTRUMENT_ROUTES');
    }
  }
};

export default routingStore;
